import { render, staticRenderFns } from "./PriceSuggestion.vue?vue&type=template&id=228edb58&scoped=true&"
import script from "./PriceSuggestion.vue?vue&type=script&lang=js&"
export * from "./PriceSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./PriceSuggestion.vue?vue&type=style&index=0&id=228edb58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228edb58",
  null
  
)

export default component.exports